import { MissionData } from '../blocks/mission'
import template from './templates/RJS05.rbxl'
import thumbnail1 from './thumbnails/RJS05/Block.png'
import thumbnail2 from './thumbnails/RJS05/SpawnLocation.png'
import thumbnail3 from './thumbnails/RJS05/Dog.png'
import thumbnail4 from './thumbnails/RJS05/Bird.png'
import thumbnail5 from './thumbnails/RJS05/Cat.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②スタートちてん',
      thumbnail: thumbnail2,
    },
    {
      name: '③いぬ',
      thumbnail: thumbnail3,
      sound: true,
    },
    {
      name: '④とり',
      thumbnail: thumbnail4,
      sound: true,
    },
    {
      name: '⑤ねこ',
      thumbnail: thumbnail5,
      sound: true,
    },
  ],
}

export default mission
